import {type Rect} from "@/event/calendar/Shapes.ts";
import {GRID_HEADER_HEIGHT, HEADER_HEIGHT} from "@/event/calendar/Constants.ts";
import {ScrollComponent} from "@/event/calendar/dom/ScrollComponent.ts";
import {CalendarView, saveView} from "@/event/calendar/CalendarModel.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {CalendarComponent} from "@/event/calendar/all/CalendarComponent.ts";
import {WeeksBodyComponent} from "@/event/calendar/weeks/WeeksBodyComponent.ts";
import {WeeksHeaderComponent} from "@/event/calendar/weeks/WeeksHeaderComponent.ts";
import {weekGridDays} from "@/event/calendar/days/DaysComponent.ts";
import {newShifted} from "@t/util/DateUtil.ts";


export class WeeksComponent extends CalendarComponent {

	private header: WeeksHeaderComponent;
	private scroll: ScrollComponent;
	private grid: WeeksBodyComponent;

	constructor(view: CalendarView) {
		super(view);
		this.grid = new WeeksBodyComponent(view);
		this.scroll = new ScrollComponent(this.grid, false);
		this.append(this.scroll);
		this.append(this.header = new WeeksHeaderComponent());
	}


	placeChildren(dc: DrawingContext, contentBox: Rect) {
		this.header.x = contentBox.x;
		this.header.y = contentBox.y;
		this.header.width = contentBox.width;
		this.header.height = GRID_HEADER_HEIGHT;

		this.scroll.x = contentBox.x;
		this.scroll.y = contentBox.y + GRID_HEADER_HEIGHT;
		this.scroll.width = contentBox.width;
		this.scroll.height = contentBox.height - GRID_HEADER_HEIGHT;
	}

	moveToDate(d:Date, smooth=true) {
		this.grid.updateScrollForNewSelectedDate(d);
		this.view.focused = null;
		this.scroll.scrollTo(0, 0, smooth);
	}

	moveToToday(max: boolean = false) {
		this.moveToDate(new Date());
	}


	moveToPrevious(max: boolean = false) {
		const anchorDate = newShifted(this.grid.firstVisibleDate(), max ? -7 : -7 * this.grid.monthGridWeeks());
		this.moveToDate(anchorDate);
	}

	moveToNext(max: boolean = false) {
		const anchorDate = newShifted(this.grid.firstVisibleDate(), max ? 7 : 7 * this.grid.monthGridWeeks());
		this.moveToDate(anchorDate);
	}


	zoomIn(max = false) {
		const mgw = this.grid.monthGridWeeks();
		if (mgw > 1) {
			this.view.weeks = max ? 1 : mgw - 1;
			saveView(this.view);
			this.dirty(true);
		}
	}

	zoomOut(max = false) {
		const mgw = this.grid.monthGridWeeks();
		if (mgw < 12) {
			this.view.weeks = max ? (mgw < 5 ? 5 : 12) : mgw + 1;
			saveView(this.view);
			this.dirty(true);
		}
	}
}
